import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { SelectProps } from "./types";
import useOptions from "./hooks";
import styles from "./styles";
import Label from "./label";

export const Select = (props: SelectProps) => {
    const {
        name,
        options,
        label,
        cssName,
        labelCssName,
        fieldOptions,
        ...rest
    } = props;

    const { register, formState: { errors }, watch } = useFormContext();

    const [getValue, getLabel] = useOptions(options);

    const watchValue = props.watch ? watch([name]) : undefined;

    useEffect(() => {
        if (!watchValue) {
            return;
        }

        const subscription = watch((value, { name, type }) => {
            if (name !== props.name) {
                return;
            }

            props.watch(value[name])
        })
        return () => subscription.unsubscribe()
    }, watchValue);

    return (<div className={cssName}>
        <select
            className={styles.elements.select}
            {...register(name, fieldOptions)}
            {...rest}>
            {options.map((o, index) => (
                <option key={index} value={getValue(o)}>
                    {getLabel(o)}
                </option>
            ))}
        </select>

        <Label htmlFor={name} cssName={labelCssName} text={label} />

        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <p className="error">{message}</p>}
        />
    </div>);
}



export default Select;